import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "3.96vw"
        },
        card: {
            width: "100%",
            height: "280vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "0"
        },
        card: {
            width: "100%",
            height: "80.13vw",
            backgroundColor: Color.White
        }
    }
};

export const ApplicationViewLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;

    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles.wrapper}>
            <div style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <rect x="0%" y="0%" rx="3" ry="3" width="85%" height="3%"/>
                        <rect x="0%" y="4.7%" rx="3" ry="3" width="58%" height="2.85%"/>
                        <circle cx="16.78%" cy="14.67%" r="6.12%" />
                        <rect x="34.86%" y="10.75%" rx="3" ry="3" width="48.3%" height="3.25%"/>
                        <rect x="34.86%" y="15.45%" rx="3" ry="3" width="63.3%" height="2.08%"/>
                        <rect x="34.86%" y="19.05%" rx="3" ry="3" width="58.32%" height="2.51%"/>
                        <rect x="34.86%" y="22.65%" rx="10" ry="10" width="45.75%" height="2.81%"/>
                        <rect x="4.52%" y="30.76%" rx="3" ry="3" width="91.56%" height="4.31%"/>
                        <rect x="4.52%" y="36.12%" rx="5" ry="5" width="63.75%" height="2.81%"/>
                        <rect x="4.52%" y="42.53%" rx="3" ry="3" width="91.56%" height="4.56%"/>
                        <rect x="4.52%" y="49.2%" rx="3" ry="3" width="14.5%" height="2.86%"/>
                        <rect x="4.52%" y="54.6%" rx="3" ry="3" width="91.56%" height="39.86%"/>
                    </> :
                    <>
                        <rect x="3.28%" y="3.78%" rx="3" ry="3" width="25%" height="3%"/>
                        <rect x="76.39%" y="6.93%" rx="3" ry="3" width="14.2%" height="3.25%"/>
                        <circle cx="15.78%" cy="19.67%" r="4.87%" />
                        <rect x="20.86%" y="14.15%" rx="3" ry="3" width="12.3%" height="2.89%"/>
                        <rect x="20.86%" y="17.35%" rx="3" ry="3" width="15.3%" height="1.68%"/>
                        <rect x="20.86%" y="19.45%" rx="3" ry="3" width="14.3%" height="1.68%"/>
                        <rect x="20.86%" y="21.88%" rx="7" ry="7" width="10.3%" height="2.18%"/>
                        <rect x="20.86%" y="27.88%" rx="3" ry="3" width="15.3%" height="3.83%"/>
                        <rect x="38.86%" y="29.18%" rx="3" ry="3" width="10.3%" height="2.38%"/>
                        <rect x="11.26%" y="39.18%" rx="3" ry="3" width="62.3%" height="3.08%"/>
                        <rect x="11.26%" y="44.08%" rx="3" ry="3" width="9.3%" height="2.89%"/>
                        <rect x="11.26%" y="49.6%" rx="3" ry="3" width="77.56%" height="44.86%"/>
                    </>}                     
                </ContentLoader>
            </div>
        </div>
    );
}